interface PixelDecorationProps {
  variant?: 'corner' | 'line' | 'dot';
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  color?: 'primary' | 'accent' | 'neon-green' | 'neon-pink' | 'neon-cyan';
}

export const PixelDecoration = ({
  variant = 'corner',
  position = 'top-left',
  color = 'primary',
}: PixelDecorationProps) => {
  const colorMap = {
    primary: 'bg-brand-primary',
    accent: 'bg-brand-accent',
    'neon-green': 'bg-neon-green',
    'neon-pink': 'bg-neon-pink',
    'neon-cyan': 'bg-neon-cyan',
  };

  const positionMap = {
    'top-left': 'top-0 left-0',
    'top-right': 'top-0 right-0',
    'bottom-left': 'bottom-0 left-0',
    'bottom-right': 'bottom-0 right-0',
  };

  const bgColor = colorMap[color];
  const positionClass = positionMap[position];

  if (variant === 'corner') {
    return (
      <div className={`absolute ${positionClass} w-6 h-6 opacity-20`}>
        {/* Pixelated corner */}
        <div className={`absolute w-2 h-2 ${bgColor}`} style={{ top: 0, left: 0 }} />
        <div className={`absolute w-2 h-2 ${bgColor}`} style={{ top: 0, left: '8px' }} />
        <div className={`absolute w-2 h-2 ${bgColor}`} style={{ top: 0, left: '16px' }} />
        <div className={`absolute w-2 h-2 ${bgColor}`} style={{ top: '8px', left: 0 }} />
        <div className={`absolute w-2 h-2 ${bgColor}`} style={{ top: '16px', left: 0 }} />
      </div>
    );
  }

  if (variant === 'line') {
    return (
      <div className={`absolute ${positionClass} flex gap-1 opacity-30`}>
        <div className={`w-1 h-1 ${bgColor}`} />
        <div className={`w-1 h-1 ${bgColor}`} />
        <div className={`w-1 h-1 ${bgColor}`} />
        <div className={`w-1 h-1 ${bgColor}`} />
        <div className={`w-1 h-1 ${bgColor}`} />
      </div>
    );
  }

  // variant === 'dot'
  return (
    <div className={`absolute ${positionClass} w-2 h-2 ${bgColor} opacity-40 animate-pulse`} />
  );
};
